import { render } from "./CustomersDashboard.vue?vue&type=template&id=a7b4466e&scoped=true&lang=pug"
import script from "./CustomersDashboard.vue?vue&type=script&lang=js"
export * from "./CustomersDashboard.vue?vue&type=script&lang=js"

import "./CustomersDashboard.vue?vue&type=style&index=0&id=a7b4466e&lang=scss&scoped=true"
import "./CustomersDashboard.vue?vue&type=style&index=1&id=a7b4466e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b4466e"]])

export default __exports__